module.exports = new __parcel__URL__("soleil-pluie-1.7c82d183.svg").toString();